// The one map look for the whole app (TASK-202: pickers and the sites map
// share a base so a site looks the same wherever it is drawn).
//
// Mapbox Standard in its "monochrome" theme (ui-tweaks, 24 Sep 2026): a
// greyscale basemap that leaves colour to what we draw on it — orange pins,
// the compliance reds/ambers/greens, the picker's marker — where the previous
// streets-v12 base put red and pink POI icons next to red/amber pins.
//
// The static map images (Sites::MapImageService, Blocks::MapImageService,
// Sites::ReportMapCacheService) cannot use Standard — the Static Images API
// rejects it — so they draw light-v11, the greyscale classic style, as the
// nearest match. Keep the two in step if this changes.
//
// Standard's themes are "default", "faded" and "monochrome"; `config` is the
// mapbox-gl v3 way to choose one. Layers a controller adds without a `slot`
// sit above Standard's labels, which is where pins belong.
export const MAP_STYLE = "mapbox://styles/mapbox/standard"
export const MAP_CONFIG = { basemap: { theme: "monochrome" } }
